import { useState } from "react";
import { testimonials } from "@/mocks/testimonials";

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];

  const goNext = () => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  };

  const goPrev = () => {
    setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl italic text-foreground-400 text-center mb-12">
          ( What Shoppers Say )
        </h2>

        <div className="relative">
          <div className="flex items-start gap-6 md:gap-10">
            <div className="hidden md:flex flex-col items-center gap-2 pt-2">
              <div className="px-3 py-1.5 bg-primary-100 rounded-full flex items-center gap-1.5">
                <i className="ri-star-fill text-primary-500 text-sm"></i>
                <span className="text-primary-700 text-sm font-semibold">{t.rating}</span>
              </div>
            </div>

            <div className="flex-1">
              <blockquote className="font-heading text-lg md:text-2xl italic text-foreground-800 leading-relaxed">
                &ldquo;{t.quote}&rdquo;
              </blockquote>

              <div className="mt-6 flex items-center gap-3">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 flex items-center justify-end gap-2">
            <button
              onClick={goPrev}
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-foreground-300 text-foreground-600 hover:border-foreground-500 hover:text-foreground-950 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={goNext}
              className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}